import React from "react";
import Button from "./Button";
import {useFileDownloader} from "../../hooks";
import _ from "lodash";
import {clearButtonProcessing, setButtonProcessing} from "../../store/actions";
import {useDispatch} from "react-redux";

const ButtonDownloadLog = ({ id, apiUrl, buttonId = '' }) => {
  const dispatch = useDispatch();
  const { downloadFileFromPath } = useFileDownloader();

  const handleDownload = (id) => {
    if (!_.isEmpty(buttonId)) {
      dispatch(setButtonProcessing(buttonId));
    }
    const url = `${apiUrl}/${id}`;
    downloadFileFromPath(url).then().finally(() => {
      if (!_.isEmpty(buttonId)) {
        dispatch(clearButtonProcessing(buttonId));
      }
    });
  };

  return (
    <Button
      type="button"
      color="light"
      className="lg:w-[160px] w-[120px] lg:h-9 h-8"
      onClick={() => handleDownload(id)}
      id={buttonId}
    >
      <span className="lg:text-base text-[15px]">ダウンロード</span>
    </Button>
  );
};

export default ButtonDownloadLog;
